import { useRef, useState } from "react";
import moment from "moment";
import { DateTimePicker } from "@mui/x-date-pickers";
import { makeStyles } from "tss-react/mui";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ datePicker: { fontSize: "0.8rem" } }); });
export var dateTimeFormat = "MMM DD, YYYY [at] h:mm a";
export var timeFormat = "h:mm a";
export function DateTimeCell(props) {
    var _a = useState(moment(props.value || undefined)), date = _a[0], setDate = _a[1];
    var dateRef = useRef(date);
    dateRef.current = date;
    var _b = useState(null), elRef = _b[0], setElRef = _b[1];
    var styles = useStyles().classes;
    return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(DateTimePicker, { onClose: function () { var date = dateRef.current; if (!date) {
                    props.onCancel();
                    return;
                } props.onChange(date.toJSON(), { tab: 1 }); }, open: elRef !== null, className: styles.datePicker, format: dateTimeFormat, value: date, openTo: "hours", onChange: function (e) {
                    if (e == null)
                        return; // also set ref b/c onClose is called too fast after onChange some times
                    dateRef.current = e.startOf("minute");
                    setDate(dateRef.current);
                } }), /*#__PURE__*/ _jsx("div", { ref: setElRef })] });
}
